import type { UsageTrackData } from "../../../backend/usage-track/UsageTrackApi";
import type { TypedAction } from "../../../generic/redux/TypedRedux";

import { CLEAR_TRACK_DATA, FLUSH_TRACK_DATA, TAG_MANAGER_DATA_LAYER_LOADED, TRACK } from "./UsageTrackActionTypes";

export type UsageTrack = UsageTrackData & TypedAction<typeof TRACK>;

export function usageTrack(data: UsageTrackData): UsageTrack {
	return {
		type: TRACK,
		...data,
	};
}

export type FlushTrackData = TypedAction<typeof FLUSH_TRACK_DATA>;

export function flushTrackData(): FlushTrackData {
	return {
		type: FLUSH_TRACK_DATA,
	};
}

export type ClearTrackData = TypedAction<typeof CLEAR_TRACK_DATA>;

export function clearTrackData(): ClearTrackData {
	return {
		type: CLEAR_TRACK_DATA,
	};
}

export type TagManagerDataLayerLoaded = TypedAction<typeof TAG_MANAGER_DATA_LAYER_LOADED>;

export function tagManagerDataLayerLoaded(): TagManagerDataLayerLoaded {
	return {
		type: TAG_MANAGER_DATA_LAYER_LOADED,
	};
}
